<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeDetailProfile from '../../../../../../employees/components/EmployeeDetailProfile.vue'

import { Employee } from '../../../../../../employees/models/employee'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, employee } = defineProps<{
  siteId: SiteID
  employee: Employee
}>()
</script>

<template>
  <EmployeeDetailProfile :site-id="siteId" :employee="employee" />
</template>
